import { DataBean } from "../DataBean";

export class FunctionalAreavdos extends DataBean {


    public async getFunctionalAreaByIDFunctionalArea(idFunctionalArea: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.FunctionalArea_getFunctionalAreaByIDFunctionalArea_Number", [idFunctionalArea]);
    }
}